import React, { Component } from 'react';
import './Card.scss';

class Card extends Component {
  constructor(props) {
    super(props)

    var row,
        rowEnd;
    if (typeof(props.row) === "object") {
      row = props.row[0]
      rowEnd = props.row[1]
    }
    else {
      row = props.row;
      rowEnd = props.row;
    }

    var column,
        columnEnd;
    if (typeof(props.column) === "object") {
      column = props.column[0]
      columnEnd = props.column[1]
    }
    else {
      column = props.column;
      columnEnd = props.column;
    }

    this.state = {
      id: this.props.id,
      type: this.props.type,
      row: row,  // can be a number (card will be on one row), or an array with two numbers: [start row, end row]
      column: column,  // can be a number (card will be on one column) or an array with two numbers: [start column, end column]
      rowEnd: rowEnd,
      columnEnd: columnEnd,
      image: this.props.image,
      contents: this.props.contents,
      onClick: this.props.onClick  // a function of event and the contents/image
    };
  }

  render() {
    var content = {
      image: (<img key={this.state.image} id={this.state.id} onClick={this.state.onClick ? e => this.state.onClick(e, {image: this.state.image}) : undefined} className="Card-image" src={this.state.image} alt=""></img>),
      'image-header': (<img key={this.state.image} id={this.state.id} onClick={this.state.onClick ? e => this.state.onClick(e, {image: this.state.image}) : undefined} className="Card-image-header" src={this.state.image} alt=""></img>),
      'image-link': (<img onClick={this.props.onClick} id={this.state.id} className="Card-image Card-image-link" src={this.state.image} alt=""></img>),

      text: (<p className={"paragraph"} id={this.state.id}>{this.state.contents}</p>),
      'text-no-padding': (<p className={"paragraph Card-text-no-padding"} id={this.state.id}>{this.state.contents}</p>),
      'text-centered': (<div className={"Card-centered-outer"} id={this.state.id}><p className={"Card-centered-inner paragraph"}>{this.state.contents}</p></div>),
      'text-centered-note': (<div className={"Card-centered-outer"} id={this.state.id}><p className={"Card-centered-inner paragraph font-serif"}><em>{this.state.contents}</em></p></div>),

      header: (<p className={"header"} id={this.state.id}>{this.state.contents}</p>),
      'header-white': (<div className={"Card-centered-outer"} id={this.state.id}><p className={"Card-centered-inner giant-header font-white"}>{this.state.contents}</p></div>),
      'header-2': (<p><span className='header font-serif font-size-1' id={this.state.id}>{this.state.contents}</span></p>)
    }[this.state.type]

    return (
      <div className={`Card
                       Card-position-${this.state.row}-${this.state.column}
                       Card-span-${this.state.rowEnd}-${this.state.columnEnd}`}>
        {content}
      </div>
    )
  }
}

export default Card;
